import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import AddWasteCollection from "./collect-waste";
import { makeStyles } from "@material-ui/core/styles";
import apiRequest from "../common/api-request";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Button from "@material-ui/core/Button";
import moment from "moment";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import Backdrop from "@material-ui/core/Backdrop";
import { CircularProgress } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    overflow: "hidden",
    padding: theme.spacing(1, 1),
  },
  paper: {
    margin: `${theme.spacing(1)}px auto`,
    padding: theme.spacing(1),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const CollectedWaste = (props) => {
  const { handleLogOut } = props;
  const classes = useStyles();
  const initialState = {
    allCollectedWaste: [],
    collectionTypes: [],
    collectionCenters: [],
    wasteTypes: [],
    materialTypes: [],
    unitsOfMeasure: [],
    action: "Close",
    collectedWaste: {
      datecollected: moment(),
      measureunit: process.env.REACT_APP_DEFAULT_MEASUREUNIT,
    },
    addAnother: false,
    displaySnackBar: false,
    snackBarMessage: "",
    snackBarautoHideDuration: 2000, //milliseconds
    snackBarVerticalPosition: "top",
    snackBarHorizontalPosition: "right",
    snackBarSeverity: "info",
    loading: false,
  };

  const [state, setState] = useState(initialState);

  const {
    allCollectedWaste,
    action,
    collectedWaste,
    collectionTypes,
    collectionCenters,
    wasteTypes,
    materialTypes,
    unitsOfMeasure,
    addAnother,
    displaySnackBar,
    snackBarMessage,
    snackBarautoHideDuration,
    snackBarVerticalPosition,
    snackBarHorizontalPosition,
    snackBarSeverity,
    loading,
  } = state;

  const handleLoader = (action) => {
    setState((prevState) => ({
      ...prevState,
      loading: action,
    }));
  };
  const showNotification = (msg, severity) => {
    if (severity.toLowerCase() === "error" && msg.search("401") !== -1) {
      handleLogOut({ msg: "Unauthorized", severity: "error" });
      return;
    }

    if (severity.toLowerCase() === "error" && msg.search("403") !== -1) {
      handleLogOut({ msg: "Token expired", severity: "error" });
      return;
    }

    setState((prevState) => ({
      ...prevState,
      displaySnackBar: true,
      snackBarMessage: msg,
      snackBarSeverity: severity,
    }));
  };

  const handleCloseSnackBar = () => {
    setState((prevState) => ({
      ...prevState,
      displaySnackBar: false,
      isLoading: false,
    }));
  };

  const handleApiData = (params) => {
    const { data, dataName, severity, status } = params;
    let snackBarMessage = "Success.";
    if (severity === "error") {
      snackBarMessage = `${status}: ${data}`;
    }

    if (
      Array.isArray(data || data?.results) ||
      Array.isArray(data?.userwaste)
    ) {
      let allCollectedWaste;
      if (dataName === `allCollectedWaste`) {
        allCollectedWaste = data?.userwaste;
        allCollectedWaste = allCollectedWaste.filter(
          (waste) => !waste?.deleted_at
        );
      }
      setState((prevState) => ({
        ...prevState,
        [dataName]:
          dataName === `allCollectedWaste`
            ? allCollectedWaste
            : data || data?.results,
        action: addAnother ? action : "Close",
        collectedWaste: {
          datecollected: moment(),
          measureunit: process.env.REACT_APP_DEFAULT_MEASUREUNIT,
        },
      }));
    }

    if (
      severity !== "error" &&
      (dataName === `addedCollectedWaste` ||
        dataName === `updatedCollectedWaste`)
    ) {
      (async () => {
        await makeApiRequest({
          uri: `/waste/collection/user/data`,
          dataName: `allCollectedWaste`,
          method: `get`,
          data: {},
        });
      })();
    }
    showNotification(snackBarMessage, severity);
    return `${dataName}: ${severity}`;
  };

  const makeApiRequest = async (params) => {
    const { uri, dataName, method, data } = params;
    const requestParams = {
      handleLoader,
      url: `${process.env.REACT_APP_API_URL}${uri}`,
      data,
      callBack: handleApiData,
      method,
      dataName,
    };
    return apiRequest(requestParams);
  };

  const handleButtonClick = (action) => {
    setState((prevState) => ({
      ...prevState,
      action: addAnother && action === "Add" ? "Add" : action,
      collectedWaste:
        action === `Close`
          ? {
              datecollected: moment(),
              measureunit: process.env.REACT_APP_DEFAULT_MEASUREUNIT,
            }
          : prevState.collectedWaste,
    }));
  };

  const handleAddAnother = () => {
    setState((prevState) => ({
      ...prevState,
      addAnother: !prevState.addAnother,
    }));
  };

  const handleCollectionChange = async (collectedWaste) => {
    const { action } = state;
    handleLoader(true);
    if (action === `Add`)
      await makeApiRequest({
        uri: `/waste/collection/data`,
        dataName: `addedCollectedWaste`,
        method: `post`,
        data: collectedWaste,
      });
    if (action === `Update`)
      await makeApiRequest({
        uri: `/waste/collection/data/${collectedWaste.id}`,
        dataName: `updatedCollectedWaste`,
        method: `put`,
        data: collectedWaste,
      });
    handleLoader(false);
  };

  useEffect(() => {
    let initDataPromises = [];

    const getAllCollectedWaste = makeApiRequest({
      uri: `/waste/collection/user/data`,
      dataName: `allCollectedWaste`,
      method: `get`,
      data: {},
    });

    initDataPromises = [...initDataPromises, getAllCollectedWaste];

    const getAllCollectionTypes = makeApiRequest({
      uri: `/waste/collection/types/all`,
      dataName: `collectionTypes`,
      method: `get`,
      data: {},
    });

    initDataPromises = [...initDataPromises, getAllCollectionTypes];

    const getAllCollectionCenters = makeApiRequest({
      uri: `/waste/collection/center/all`,
      dataName: `collectionCenters`,
      method: `get`,
      data: {},
    });

    initDataPromises = [...initDataPromises, getAllCollectionCenters];

    const getAllWasteTypes = makeApiRequest({
      uri: `/waste/type/all`,
      dataName: `wasteTypes`,
      method: `get`,
      data: {},
    });

    initDataPromises = [...initDataPromises, getAllWasteTypes];

    const getAllMaterialTypes = makeApiRequest({
      uri: `/waste/material/type/all`,
      dataName: `materialTypes`,
      method: `get`,
      data: {},
    });

    initDataPromises = [...initDataPromises, getAllMaterialTypes];

    const getAllUnitsOfMeasure = makeApiRequest({
      uri: `/waste/measure/units/all`,
      dataName: `unitsOfMeasure`,
      method: `get`,
      data: {},
    });

    initDataPromises = [...initDataPromises, getAllUnitsOfMeasure];

    (async () => {
      handleLoader(true);
      await Promise.all(initDataPromises)
        .then((results) => {
          // console.log({ results });
        })
        .catch((error) => console.log({ error }));
      handleLoader(false);
    })();
  }, []);

  const columns = [
    {
      label: "Collection Type",
      name: "collectiontype",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      label: "Collection Center",
      name: "collectioncenter",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      label: "Waste Type",
      name: "wastetype",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      label: "Material Type",
      name: "materialtype",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      label: "Measure Unit",
      name: "measureunit",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      label: "Details",
      name: "details",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      label: "Make",
      name: "make",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      label: "Model",
      name: "model",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      label: "Serial Number",
      name: "serial_number",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      label: "Weight",
      name: "weight",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      label: "Quantity",
      name: "quantity",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return parseInt(value);
        },
      },
    },
    {
      label: "Created By",
      name: "useremail",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      label: "Collection Date",
      name: "datecollected",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return moment(value).format("DD-MMM-YYYY");
        },
      },
    },
  ];

  const options = {
    jumpToPage: true,
    onRowClick: (_rowData, rowMeta) => {
      if (rowMeta?.dataIndex >= 0) {
        const collectedWaste = { ...allCollectedWaste[rowMeta?.dataIndex] };
        const collectiontype = collectionTypes.filter((collectiontype) => {
          return collectiontype.name === collectedWaste.collectiontype;
        });
        collectedWaste.collectiontype = collectiontype[0]?.id;
        const collectioncenter = collectionCenters.filter(
          (collectioncenter) => {
            return collectioncenter.name === collectedWaste.collectioncenter;
          }
        );
        collectedWaste.collectioncenter = collectioncenter[0]?.id;
        const wastetype = wasteTypes.filter((wastetype) => {
          return wastetype.name === collectedWaste.wastetype;
        });
        collectedWaste.wastetype = wastetype[0]?.id;
        const materialtype = materialTypes.filter((materialtype) => {
          return materialtype.name === collectedWaste.materialtype;
        });
        collectedWaste.materialtype = materialtype[0]?.id;
        const measureunit = unitsOfMeasure.filter((measureunit) => {
          return measureunit.name === collectedWaste.measureunit;
        });
        collectedWaste.measureunit = measureunit[0]?.id;
        setState((prevState) => ({
          ...prevState,
          collectedWaste,
          action: "Update",
        }));
      }
    },
    onRowsDelete: (rowsDeleted) => {
      if (!window.confirm(`Are you sure you wish to delete this item?`))
        return false;
      if (Array.isArray(rowsDeleted?.data) && rowsDeleted?.data?.length > 0) {
        rowsDeleted.data.forEach((dataItem, index) => {
          const collectedWaste = allCollectedWaste[dataItem.dataIndex];
          if (collectedWaste?.id) {
            (async () => {
              await makeApiRequest({
                uri: `/waste/collection/data/${collectedWaste?.id}`,
                dataName: `deletedCollectedWaste`,
                method: `delete`,
                data: {},
              });
              if (index === rowsDeleted.data.length - 1)
                await makeApiRequest({
                  uri: `/waste/collection/user/data`,
                  dataName: `allCollectedWaste`,
                  method: `get`,
                  data: {},
                });
            })();
          }
        });
      }
    },
  };

  return (
    <div>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress />
      </Backdrop>
      <Snackbar
        anchorOrigin={{
          vertical: snackBarVerticalPosition,
          horizontal: snackBarHorizontalPosition,
        }}
        open={displaySnackBar}
        onClose={handleCloseSnackBar}
        autoHideDuration={snackBarautoHideDuration}
        // message={snackBarMessage}
      >
        <Alert onClose={handleCloseSnackBar} severity={snackBarSeverity}>
          {snackBarMessage}
        </Alert>
      </Snackbar>
      {(action === "Add" || action === "Update") && (
        <AddWasteCollection
          handleButtonClick={handleButtonClick}
          action={action}
          collectedWaste={collectedWaste}
          handleCollectionChange={handleCollectionChange}
          collectionTypes={collectionTypes}
          collectionCenters={collectionCenters}
          wasteTypes={wasteTypes}
          materialTypes={materialTypes}
          unitsOfMeasure={unitsOfMeasure}
          handleAddAnother={handleAddAnother}
          addAnother={addAnother}
          loading={loading}
        />
      )}
      <MUIDataTable
        title={
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              handleButtonClick(`Add`);
            }}
            startIcon={<AddCircleIcon />}
          >
            New Collection
          </Button>
        }
        data={allCollectedWaste}
        columns={columns}
        options={options}
      />
    </div>
  );
};
export default CollectedWaste;
